export default "__VITE_ASSET__b4572819__"